<template>
  <transition name="fade" mode="out-in">
    <div id="node-cycler" :key="currentNode.id"
         :style="{backgroundImage: `url(${getInsightsUrl()}/images/splash/node_cycler_${currentBg}.png)`}"
    >
      <div class="cycler-image">
        <a :href="`${getInsightsUrl()}/?adjectives=any&interstitial=1&id=${currentNode.id}`" target="_blank">
          <img :alt="currentNode.node_name" :src="currentNode.image_url"/>
        </a>
      </div>
      <div class="cycler-body text-center" v-html="currentNode.content"></div>
    </div>
  </transition>
</template>

<script>

const cyclerNodes = [
  {
    'node_name': 'Emma Stone',
    'id': 937551,
    'demo1': 'People in the Midwest',
    'demo2': '3x more likely',
    'demo3': 'Emma Stone',
    'list_name': 'Famous Women You\'d Want to Have a Beer With',
    'list_url': 'http://www.ranker.com/list/famous-women-beer-list/greg',
    'image_url': '//imgix.ranker.com/user_node_img/47/937551/original/emily-stone-recording-artists-and-groups-photo-u122?w=200&h=200&q=90&fm=jpg&fit=crop&crop=faces',
    'content': '<span class="cycler-demographic">People in the Midwest</span><br/><span class="cycler-story">are <strong>3x more likely</strong> to vote for<br/><a href="' + process.env.INSIGHTS_V1_HOST + '/?adjectives=any&amp;interstitial=1&amp;id=937551" target="_blank" class="node-cycler-item-link"><strong>Emma Stone</strong></a> on<br/><a href="http://www.ranker.com/list/famous-women-beer-list/greg" class="node-cycler-list-link" target="_blank"><strong>Famous Women You\'d Want to Have a Beer With</strong></a></span>'
  },
  {
    'node_name': 'Chris Pratt',
    'id': 729391,
    'demo1': 'Women',
    'demo2': '2x more likely',
    'demo3': 'Chris Pratt',
    'list_name': 'The Most Trustworthy Celebrities in the World',
    'list_url': 'http://www.ranker.com/list/most-trustworthy-celebrities/celebrity-lists',
    'image_url': '//imgix.ranker.com/user_node_img/37/729391/original/chris-pratt-photo-u47?w=200&h=200&q=90&fm=jpg&fit=crop&crop=faces',
    'content': '<span class="cycler-demographic">Women</span><br/><span class="cycler-story">are <strong>2x more likely</strong> to vote for<br/><a href="' + process.env.INSIGHTS_V1_HOST + '/?adjectives=any&amp;interstitial=1&amp;id=729391" target="_blank" class="node-cycler-item-link"><strong>Chris Pratt</strong></a> on<br/><a href="http://www.ranker.com/list/most-trustworthy-celebrities/celebrity-lists" class="node-cycler-list-link" target="_blank"><strong>The Most Trustworthy Celebrities in the World</strong></a></span>'
  },
  {
    'node_name': 'Rihanna',
    'id': 1910648,
    'demo1': 'Fans of Rihanna',
    'demo2': '3x more likely',
    'demo3': 'Katy Perry',
    'list_name': 'The Best Current Female Singers',
    'list_url': 'http://www.ranker.com/crowdranked-list/best-female-singer-of-the-year',
    'image_url': '//imgix.ranker.com/user_node_img/96/1910648/original/1910648-photo-u511?w=200&h=200&q=90&fm=jpg&fit=crop&crop=faces',
    'content': '<span class="cycler-demographic">Fans of Rihanna</span><br/><span class="cycler-story">are <strong>3x more likely</strong> to vote for<br/><a href="' + process.env.INSIGHTS_V1_HOST + '/?adjectives=any&amp;interstitial=1&amp;id=10865225" target="_blank" class="node-cycler-item-link"><strong>Katy Perry</strong></a> on<br/><a href="http://www.ranker.com/crowdranked-list/best-female-singer-of-the-year" class="node-cycler-list-link" target="_blank"><strong>The Best Current Female Singers</strong></a></span>'
  },
  {
    'node_name': 'Aziz Ansari',
    'id': 520625,
    'demo1': 'Fans of Aziz Ansari',
    'demo2': '6x more likely',
    'demo3': 'Donald Glover',
    'list_name': 'The Funniest Stand Up Comedians of All Time',
    'list_url': 'http://www.ranker.com/crowdranked-list/the-funniest-stand-up-comedians-in-entertainment',
    'image_url': '//imgix.ranker.com/user_node_img/27/520625/original/aziz-ansari-photo-u24?w=200&h=200&q=90&fm=jpg&fit=crop&crop=faces',
    'content': '<span class="cycler-demographic">Fans of Aziz Ansari</span><br/><span class="cycler-story">are <strong>6x more likely</strong> to vote for<br/><a href="' + process.env.INSIGHTS_V1_HOST + '/?adjectives=any&amp;interstitial=1&amp;id=876056" target="_blank" class="node-cycler-item-link"><strong>Donald Glover</strong></a> on<br/><a href="http://www.ranker.com/crowdranked-list/the-funniest-stand-up-comedians-in-entertainment" class="node-cycler-list-link" target="_blank"><strong>The Funniest Stand Up Comedians of All Time</strong></a></span>'
  },
  {
    'node_name': 'Shameless',
    'id': 63137784,
    'demo1': 'Fans of Shameless',
    'demo2': '2x more likely',
    'demo3': 'Django Unchained',
    'list_name': 'The Best Movies of All Time',
    'list_url': 'http://www.ranker.com/crowdranked-list/the-best-movies-of-all-time',
    'image_url': '//imgix.ranker.com/user_node_img/3157/63137784/original/shameless-tv-programs-photo-u7?w=200&h=200&q=90&fm=jpg&fit=crop&crop=faces',
    'content': '<span class="cycler-demographic">Fans of Shameless</span><br/><span class="cycler-story">are <strong>2x more likely</strong> to vote for<br/><a href="' + process.env.INSIGHTS_V1_HOST + '/?adjectives=any&amp;interstitial=1&amp;id=63369593" target="_blank" class="node-cycler-item-link"><strong>Django Unchained</strong></a> on<br/><a href="http://www.ranker.com/crowdranked-list/the-best-movies-of-all-time" class="node-cycler-list-link" target="_blank"><strong>The Best Movies of All Time</strong></a></span>'
  },
  {
    'node_name': 'The Walking Dead',
    'id': 54928859,
    'demo1': 'Fans of The Walking Dead',
    'demo2': '2x more likely',
    'demo3': 'Blink 182',
    'list_name': 'The Best Rock Bands of All Time',
    'list_url': 'http://www.ranker.com/crowdranked-list/the-best-rock-bands-of-all-time',
    'image_url': '//imgix.ranker.com/user_node_img/2747/54928859/original/54928859-photo-u70?w=200&h=200&q=90&fm=jpg&fit=crop&crop=faces',
    'content': '<span class="cycler-demographic">Fans of The Walking Dead</span><br/><span class="cycler-story">are <strong>2x more likely</strong> to vote for<br/><a href="' + process.env.INSIGHTS_V1_HOST + '/?adjectives=any&amp;interstitial=1&amp;id=23781596" target="_blank" class="node-cycler-item-link"><strong>Blink 182</strong></a> on<br/><a href="http://www.ranker.com/crowdranked-list/the-best-rock-bands-of-all-time" class="node-cycler-list-link" target="_blank"><strong>The Best Rock Bands of All Time</strong></a></span>'
  },
  {
    'node_name': 'Carrie Underwood',
    'id': 678602,
    'demo1': 'Fans of Carrie Underwood',
    'demo2': '4x more likely',
    'demo3': 'Jennifer Garner',
    'list_name': 'The Best Living American Actresses',
    'list_url': 'http://www.ranker.com/list/best-living-american-actresses/ranker-film',
    'image_url': '//imgix.ranker.com/user_node_img/34/678602/original/678602-photo-u163?w=200&h=200&q=90&fm=jpg&fit=crop&crop=faces',
    'content': '<span class="cycler-demographic">Fans of Carrie Underwood</span><br/><span class="cycler-story">are <strong>4x more likely</strong> to vote for<br/><a href="' + process.env.INSIGHTS_V1_HOST + '/?adjectives=any&amp;interstitial=1&amp;id=1281378" target="_blank" class="node-cycler-item-link"><strong>Jennifer Garner</strong></a> on<br/><a href="http://www.ranker.com/list/best-living-american-actresses/ranker-film" class="node-cycler-list-link" target="_blank"><strong>The Best Living American Actresses</strong></a></span>'
  },
  {
    'node_name': 'Stephen Colbert',
    'id': 2093085,
    'demo1': 'Fans of Stephen Colbert',
    'demo2': '2x more likely',
    'demo3': 'Brooklyn Nine-Nine',
    'list_name': 'The Best Current Sitcoms',
    'list_url': 'http://www.ranker.com/list/best-current-tv-sitcoms/ranker-tv',
    'image_url': '//imgix.ranker.com/user_node_img/105/2093085/original/stephen-colbert-photo-u43?w=200&h=200&q=90&fm=jpg&fit=crop&crop=faces',
    'content': '<span class="cycler-demographic">Fans of Stephen Colbert</span><br/><span class="cycler-story">are <strong>2x more likely</strong> to vote for<br/><a href="' + process.env.INSIGHTS_V1_HOST + '/?adjectives=any&amp;interstitial=1&amp;id=73676744" target="_blank" class="node-cycler-item-link"><strong>Brooklyn Nine-Nine</strong></a> on<br/><a href="http://www.ranker.com/list/best-current-tv-sitcoms/ranker-tv" class="node-cycler-list-link" target="_blank"><strong>The Best Current Sitcoms</strong></a></span>'
  },
  {
    'node_name': 'Will Smith',
    'id': 2399718,
    'demo1': 'Fans of Will Smith',
    'demo2': '4x more likely',
    'demo3': 'Mark Wahlberg',
    'list_name': 'The All-Time Greatest Action Stars',
    'list_url': 'http://www.ranker.com/crowdranked-list/best-action-stars',
    'image_url': '//imgix.ranker.com/user_node_img/120/2399718/original/will-smith-photo-u116?w=200&h=200&q=90&fm=jpg&fit=crop&crop=faces',
    'content': '<span class="cycler-demographic">Fans of Will Smith</span><br/><span class="cycler-story">are <strong>4x more likely</strong> to vote for<br/><a href="' + process.env.INSIGHTS_V1_HOST + '/?adjectives=any&amp;interstitial=1&amp;id=1528445" target="_blank" class="node-cycler-item-link"><strong>Mark Wahlberg</strong></a> on<br/><a href="http://www.ranker.com/crowdranked-list/best-action-stars" class="node-cycler-list-link" target="_blank"><strong>The All-Time Greatest Action Stars</strong></a></span>'
  },
  {
    'node_name': 'Margot Robbie',
    'id': 32800165,
    'demo1': 'Fans of Margot Robbie',
    'demo2': '3x more likely',
    'demo3': 'Game of Thrones',
    'list_name': 'The Best TV Shows Currently on the Air',
    'list_url': 'http://www.ranker.com/crowdranked-list/best-shows-currently-on-the-air',
    'image_url': '//imgix.ranker.com/user_node_img/1641/32800165/original/margot-robbie-photo-u114?w=200&h=200&q=90&fm=jpg&fit=crop&crop=faces',
    'content': '<span class="cycler-demographic">Fans of Margot Robbie</span><br/><span class="cycler-story">are <strong>3x more likely</strong> to vote for<br/><a href="' + process.env.INSIGHTS_V1_HOST + '/?adjectives=any&amp;interstitial=1&amp;id=13122684" target="_blank" class="node-cycler-item-link"><strong>Game of Thrones</strong></a> on<br/><a href="http://www.ranker.com/crowdranked-list/best-shows-currently-on-the-air" class="node-cycler-list-link" target="_blank"><strong>The Best TV Shows Currently on the Air</strong></a></span>'
  },
  {
    'node_name': 'Transformers',
    'id': 2271732,
    'demo1': 'Fans of Transformers',
    'demo2': '3x more likely',
    'demo3': 'Divergent',
    'list_name': 'The Very Best Movie Franchises',
    'list_url': 'http://www.ranker.com/crowdranked-list/5-star-movie-franchises',
    'image_url': '//imgix.ranker.com/user_node_img/114/2271732/original/transformers-photo-u23?w=200&h=200&q=90&fm=jpg&fit=crop&crop=faces',
    'content': '<span class="cycler-demographic">Fans of Transformers</span><br/><span class="cycler-story">are <strong>3x more likely</strong> to vote for<br/><a href="' + process.env.INSIGHTS_V1_HOST + '/?adjectives=any&amp;interstitial=1&amp;id=67497874" target="_blank" class="node-cycler-item-link"><strong>Divergent</strong></a> on<br/><a href="http://www.ranker.com/crowdranked-list/5-star-movie-franchises" class="node-cycler-list-link" target="_blank"><strong>The Very Best Movie Franchises</strong></a></span>'
  },
  {
    'node_name': 'Madagascar',
    'id': 1495475,
    'demo1': 'Fans of Madagascar',
    'demo2': '4x more likely',
    'demo3': 'The Hunger Games',
    'list_name': 'The Best Movies of All Time',
    'list_url': 'http://www.ranker.com/crowdranked-list/the-best-movies-of-all-time',
    'image_url': '//imgix.ranker.com/node_img/75/1495475/original/madagascar-films-photo-1?w=200&h=200&q=90&fm=jpg&fit=crop&crop=faces',
    'content': '<span class="cycler-demographic">Fans of Madagascar</span><br/><span class="cycler-story">are <strong>4x more likely</strong> to vote for<br/><a href="' + process.env.INSIGHTS_V1_HOST + '/?adjectives=any&amp;interstitial=1&amp;id=61949979" target="_blank" class="node-cycler-item-link"><strong>The Hunger Games</strong></a> on<br/><a href="http://www.ranker.com/crowdranked-list/the-best-movies-of-all-time" class="node-cycler-list-link" target="_blank"><strong>The Best Movies of All Time</strong></a></span>'
  },
  {
    'node_name': 'Catfish: The TV Show',
    'id': 73656114,
    'demo1': 'Fans of Catfish: The TV Show',
    'demo2': '2x more likely',
    'demo3': 'Bar Rescue',
    'list_name': 'The Best Reality TV Shows Ever',
    'list_url': 'http://www.ranker.com/crowdranked-list/the-most-actually-watchable-reality-tv-shows',
    'image_url': '//imgix.ranker.com/user_node_img/3683/73656114/original/catfish-the-tv-show-tv-programs-photo-u1?w=200&h=200&q=90&fm=jpg&fit=crop&crop=faces',
    'content': '<span class="cycler-demographic">Fans of Catfish: The TV Show</span><br/><span class="cycler-story">are <strong>2x more likely</strong> to vote for<br/><a href="' + process.env.INSIGHTS_V1_HOST + '/?adjectives=any&amp;interstitial=1&amp;id=73337907" target="_blank" class="node-cycler-item-link"><strong>Bar Rescue</strong></a> on<br/><a href="http://www.ranker.com/crowdranked-list/the-most-actually-watchable-reality-tv-shows" class="node-cycler-list-link" target="_blank"><strong>The Best Reality TV Shows Ever</strong></a></span>'
  }
];

export default {
  name: 'NodeCycler',
  data() {
    return {
      currentIndex: -1,
      nodeCyclerTimeout: null
    };
  },
  computed: {
    currentBg() {
      return (this.currentIndex % 4) + 1; // there are 4 bgs available
    },
    currentNode() {
      return cyclerNodes[this.currentIndex];
    }
  },
  created() {
    this.cycleNodes();
  },
  beforeDestroy() {
    clearTimeout(this.nodeCyclerTimeout);
  },
  methods: {
    getInsightsUrl() {
      return process.env.INSIGHTS_V1_HOST;
    },
    cycleNodes() {
      this.nodeCyclerTimeout = setTimeout(this.cycleNodes, 6000);
      this.currentIndex = (this.currentIndex + 1) % cyclerNodes.length;
    }
  }
};
</script>

<style lang="postcss">
#node-cycler {
  width: 100%;
  padding-top: 80px;
  background-position-y: 80px;
  background-repeat: no-repeat;
  height: 507px;

  &.fade-enter-active, &.fade-leave-active {
    transition: opacity 1s ease;
  }
  &.fade-enter, &.fade-leave-to {
    opacity: 0;
  }

  .cycler-image {
    position: relative;
    left: 79px;
    top: 57px;
    width: 210px;
    height: 210px;
    border-radius: 5px;
    border: solid 5px white;
    background: white;

    img {
      border-radius: 5px;
    }

    box-shadow: 0 0 46px 0 rgba(136, 136, 136, 1);
  }

  .cycler-body {
    position: relative;
    top: 83px;
    padding: 0 26px;
    line-height: 1.55;

    .cycler-demographic {
      font-family: 'Roboto Condensed Bold', sans-serif;
      color: #000;
      font-size: 25px;
      text-align: center;
    }

    .cycler-story {
      font-family: 'Roboto-Regular', Roboto, Arial, Helevtica, sans-serif;
      color: #000;
      font-size: 18px;

      strong {
        font-family: 'Roboto Bold', sans-serif;
      }
    }

    a.node-cycler-item-link {
      color: #086cb8;
    }

    a.node-cycler-list-link {
      color: #000;
    }
  }
}
</style>